import ServiceApi from "../services/service.api";
const baseServiceUrl = `/api/v1/Contact`;


const ApiContact = {
  getInfos: () => {
    const url = `${baseServiceUrl}`;
    var response = ServiceApi.get(url);
    return response;
  },
};

export default ApiContact;